import { createAction } from '@reduxjs/toolkit';
import { Share } from '../../model';
import { SharedLinksShape } from './reducer';

export const selectorAllChanged = createAction<
  { shareIds: string[] },
  'ch/shatedLinks/selectorAllChanged'
>('ch/shatedLinks/selectorAllChanged');
export const setInProgress = createAction<{ inProgress: SharedLinksShape['inProgress'] }>(
  'ch/sharedLinks/setInProgress',
);
export const sharesChanged = createAction<{ shares: Share[]; total: number }>(
  'ch/shatedLinks/sharesChanged',
);
export const loadSharesRequested = createAction<void, 'ch/shatedLinks/loadSharesRequested'>(
  'ch/shatedLinks/loadSharesRequested',
);
export const expirationChanged = createAction<
  { expiration: string },
  'ch/shatedLinks/expirationChanged'
>('ch/shatedLinks/expirationChanged');

export const expirationButtonClicked = createAction<void, 'ch/shatedLinks/expirationButtonClicked'>(
  'ch/shatedLinks/expirationButtonClicked',
);
export const saveExpirationStarted = createAction<void, 'ch/shatedLinks/saveExpirationStarted'>(
  'ch/shatedLinks/saveExpirationStarted',
);
export const saveExpirationSuccess = createAction<
  { result: any },
  'ch/shatedLinks/saveExpirationSuccess'
>('ch/shatedLinks/saveExpirationSuccess');
export const saveExpirationError = createAction<
  { error: any },
  'ch/shatedLinks/saveExpirationError'
>('ch/shatedLinks/saveExpirationError');

export const searchQueryChanged = createAction<{ searchQuery: string }>(
  'ch/sharedLinks/searchQueryChanged',
);

export const sorterChanged = createAction<SharedLinksShape['sorter']>(
  'ch/sharedLinks/sorterChanged',
);

export const paginationChanged = createAction<{
  current: SharedLinksShape['pagination']['current'];
}>('ch/sharedLinks/paginationChanged');
